/**
* @copyright
* Copyright(c) 2018 SICK AG
*/

const style = `
* {
  box-sizing: border-box;
}

:host {
  position: relative;
  text-align: left;
  color: #50585C;
  color: var(--davinci-color-text-light, #50585C);
  font-size: 1rem;
  font-weight: 600;
  display: block;
}

.label {
  flex-grow: 2;
  line-height: 1.1428571429rem;
}
.label:not(.disabled):hover {
  cursor: pointer;
}
.label:not(.disabled):hover {
  color: #009DF4;
  color: var(--davinci-color-primary-light, #009DF4);
}
.label:not(.disabled).active {
  color: #007CC1;
  color: var(--davinci-color-primary, #007CC1);
}
.label.disabled {
  color: #B1B8BC;
  color: var(--davinci-color-text-disabled, #B1B8BC);
}
.label.disabled:hover {
  cursor: not-allowed;
}
`;
export { style };
